import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-466c4219"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["for"]
const _hoisted_2 = ["name", "id"]
const _hoisted_3 = ["onClick"]

import { PropType, reactive } from "vue";
import CustomCard from "./CustomCard.vue";
import ArrowIcon from "@/assets/SVG/ArrowIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomSelect',
  props: {
  label: {
    type: String,
    required: true,
  },
  options: {
    type: Array as PropType<{ value: string; name: string }[]>,
    default: () => [],
  },
  destyle: {
    type: Boolean,
    default: false,
  },
  initialySelected: {
    type: String,
    default: "",
  },
},
  emits: ["selected"],
  setup(__props, { emit }) {

const props = __props;



const state = reactive({
  selected: props.initialySelected,
  open: false,
});



function handleSelectClick() {
  state.open = true;
}

function handleOptionSelected(name: string) {
  state.selected = name;
  state.open = false;
  emit(
    "selected",
    props.options.find((el) => el.name == name)
  );
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      __props.destyle ? 'destyle-class' : 'select-frame',
      state.selected != '' ? 'option-selected' : '',
      state.open ? 'select-frame-focused' : '',
    ]),
    onClick: handleSelectClick
  }, [
    _createElementVNode("label", {
      class: "label",
      for: __props.label
    }, _toDisplayString(__props.label), 9, _hoisted_1),
    _withDirectives(_createElementVNode("input", {
      name: __props.label,
      id: __props.label,
      class: "select",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.selected) = $event)),
      disabled: ""
    }, null, 8, _hoisted_2), [
      [_vModelText, state.selected]
    ]),
    _createVNode(ArrowIcon, { class: "icon" }),
    (state.open)
      ? (_openBlock(), _createBlock(CustomCard, {
          key: 0,
          class: "options",
          "remove-top-border": true
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "option",
                key: `${__props.label}-${option}-${index}`,
                onClick: _withModifiers(($event: any) => (handleOptionSelected(option.name)), ["stop"])
              }, _toDisplayString(option.name), 9, _hoisted_3))
            }), 128))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 2))
}
}

})